import { LayingPatternViewer } from "CommonScripts/layingPatternViewer";
import { LoadingHelper } from "CommonScripts/loadingHelper";
import { updateProductName } from "./textureSelect";

export class Resolution {
    private static resolutionOptionEls: HTMLCollectionOf<HTMLInputElement> = document.getElementsByClassName('js-resolution-change-option') as HTMLCollectionOf<HTMLInputElement>;

    public static init() {
        this.setEventListeners();
        this.setDefaultResolution();
    }

    private static setEventListeners() {
        [].slice.call(this.resolutionOptionEls).forEach((el: HTMLInputElement) => {
            el.addEventListener('click', async () => {
                LoadingHelper.start();

                try {
                    if (el.checked) {
                        const value: string = el.value;
    
                        if (value === ResolutionOption.Ultra) {
                            await LayingPatternViewer.setUltraResolution();
                        } else if (value === ResolutionOption.High) {
                            await LayingPatternViewer.setHighResolution();
                        } else if (value === ResolutionOption.Medium) {
                            await LayingPatternViewer.setMediumResolution();
                        } else if (value === ResolutionOption.Low) {
                            await LayingPatternViewer.setLowResolution();
                        }
                    }
                } finally {
                    this.setResolutionText();
                    LoadingHelper.stop();
                }
            })
        })
    }

    private static setDefaultResolution() {
        // Set timeout is here to push the encased code to the end of the execution queue as it sometimes isn't getting the correct 'current resolution'.
        setTimeout(() => {
            [].slice.call(this.resolutionOptionEls).find((el: HTMLInputElement) => el.value === LayingPatternViewer.getCurrentResolution()).checked = true;
            this.setResolutionText();
        }, 0);
    }

    private static setResolutionText() {
        const matchingResolutionInputEl: HTMLInputElement = [].slice.call(this.resolutionOptionEls).find((el: HTMLInputElement) => el.checked);
        const resolutionTextEl: Element = document.getElementsByClassName('js-resolution-change-value')[0];
        const resolutionText: string = matchingResolutionInputEl.nextElementSibling.innerHTML;

        resolutionTextEl.innerHTML = resolutionText;

        updateProductName();
    }
}

Resolution.init();

export enum ResolutionOption {
	Low = 'low',
	Medium = 'medium',
	High = 'high',
    Ultra = 'ultra'
}